<template>
  <div id="app">
    <van-skeleton
      :row="10"
      row-width="100%"
      style="margin-bottom: 10px"
      :loading="loading"
    >
      <div class="search-container">
        <img src="../../assets/search.svg" class="icon" />
        <input type="text" :placeholder="_('请搜索')" v-model="searchText" />
      </div>
      <van-list v-if="data.length > 0">
        <template v-for="item in data">
          <van-cell
            :key="item.extra.app_name"
            :value="item.extra.app_name"
            title-width="100%"
          >
            <div class="file-info">
              <div class="file-info-title">
                {{ (item.extra && item.extra.app_name) || "-" }}
              </div>
              <div class="file-info-details">
                <div>
                  {{ _("更新时间") }}
                  <span class="file-info-details-value">{{
                    timeFilter(item.releaseTime)
                  }}</span>
                </div>
                <div>
                  {{ _("大小") }}
                  <span class="file-info-details-value">{{
                    fileSizeFilter(item.fileSize)
                  }}</span>
                </div>
              </div>
              <div class="file-info-md5">
                {{ _("文件MD5") }}
                <span class="file-info-details-value">{{ item.md5 }}</span>
              </div>
              <div class="file-info-buttons">
                <van-button size="small" @click="copyText(item.md5)">{{
                  _("复制MD5")
                }}</van-button>
                <van-button
                  type="info"
                  size="small"
                  @click="copyText(item.link)"
                  >{{ _("复制下载链接") }}</van-button
                >
              </div>
            </div>
          </van-cell>
        </template>
      </van-list>
      <div v-else class="empty-container">
        <img src="../../assets/empty.svg" class="empty-img" />
        <p>{{ _("暂无数据") }}</p>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getTextArea } from "../../util/handle";
import ToastSuccess from "../../assets/toast-success.svg";

export default {
  name: "App",
  props: {
    infoData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      num: 0,
      loading: false,
      searchText: "",
    };
  },
  computed: {
    data() {
      const searchText = this.searchText;
      return this.infoData.code === 0
        ? (this.infoData.data && this.infoData.data.pkg).filter((item) => {
            return (
              !searchText ||
              (item.extra.app_name || "-")
                .toLocaleLowerCase()
                .includes((searchText || "-").toLocaleLowerCase())
            );
          })
        : [];
    },
  },
  methods: {
    timeFilter(v) {
      return v.includes(" ") ? v.split(" ")[0] : v;
    },
    fileSizeFilter(v) {
      if (v < 1024) {
        return v + " B";
      } else if (v < 1024 * 1024) {
        return (v / 1024).toFixed(0) + " KB";
      } else if (v < 1024 * 1024 * 1024) {
        return (v / (1024 * 1024)).toFixed(0) + " MB";
      } else {
        return (v / (1024 * 1024 * 1024)).toFixed(0) + " GB";
      }
    },
    copyText(text) {
      let dom = getTextArea();
      dom.value = text;
      dom.select();
      document.execCommand("copy"); // 执行浏览器复制命令
      Toast({
        message: this._("复制成功"),
        icon: ToastSuccess,
      });
    },
  },
};
</script>

<style scoped lang="stylus">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top: 15px;

  >>> .van-skeleton__row:not(:first-child) {
    width: 100% !important;
  }
}

.time {
  width: 200px !important;
}

.empty-container {
  text-align: center;
  font-size: 18px;
  padding: 45px 0 35px 0;
  color: #ccc;
}

.empty-img {
  width: 88px;
  height: 88px;
}

.to-form {
  color: #ff9900;
  text-decoration: underline;
  padding: 8px;
  text-align: center;
}

.search-container {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 0 16px 8px;
  padding: 8px 12px;
}

.search-container input {
  border: none;
  outline: none;
  flex-grow: 1;
  padding: 0 8px;
  font-size: 16px;
}

.file-info {
  padding: 12px 16px;
  border: 1px solid #ebedf0;
  border-radius: 4px;
}

.file-info-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-info-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #5E6573;
}

.file-info-details-value {
  color: #2F3540;
}

.file-info-md5 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
  color: #5E6573;
}

.file-info-buttons {
  display: flex;
  justify-content: end;
}

.van-button {
  margin-left: 8px;
}
</style>
